/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface WorkflowConditionCombination { 
    id?: string;
    condition_output_id?: string;
    left_field_id?: string;
    logic_string?: string;
    right_field_value?: string;
    combination_logic_string?: string;
    sort_oder?: number;
    created_at?: Date;
    created_by?: string;
    modified_at?: Date;
    modified_by?: string;
}